__turbopack_context__.v({
  "filter-group": "yd087W_filter-group",
  "filter-group__dropdown": "yd087W_filter-group__dropdown",
  "filter-group__dropdown__filter-tag": "yd087W_filter-group__dropdown__filter-tag",
  "filter-group__header": "yd087W_filter-group__header",
  "filter-group__header__filter-counter": "yd087W_filter-group__header__filter-counter",
  "filter-group__header__filter-counter__number": "yd087W_filter-group__header__filter-counter__number",
  "filter-group__header__link": "yd087W_filter-group__header__link",
  "filter-group__header__link--enabled": "yd087W_filter-group__header__link--enabled",
  "filter-group__list": "yd087W_filter-group__list",
  "filter-group__list--open": "yd087W_filter-group__list--open",
  "filter-group__list__labels": "yd087W_filter-group__list__labels",
  "filter-group__list__labels__item": "yd087W_filter-group__list__labels__item",
  "filter-group__list__labels__item--selected": "yd087W_filter-group__list__labels__item--selected",
  "filter-group__list__labels__item__checkmark": "yd087W_filter-group__list__labels__item__checkmark",
  "filter-group__list__labels__label": "yd087W_filter-group__list__labels__label",
  "filter-group__list__title": "yd087W_filter-group__list__title",
  "filter-group__separator": "yd087W_filter-group__separator",
});
